"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBeVisible = toBeVisible;

var _utils = require("./utils");

function isStyleVisible(element) {
  var getComputedStyle = element.ownerDocument.defaultView.getComputedStyle;

  var _getComputedStyle = getComputedStyle(element),
      display = _getComputedStyle.display,
      visibility = _getComputedStyle.visibility,
      opacity = _getComputedStyle.opacity;

  return display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse' && opacity !== '0' && opacity !== 0;
}

function isAttributeVisible(element, previousElement) {
  var detailsVisibility;

  if (previousElement) {
    detailsVisibility = element.nodeName === 'DETAILS' && previousElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true;
  } else {
    detailsVisibility = element.nodeName === 'DETAILS' ? element.hasAttribute('open') : true;
  }

  return !element.hasAttribute('hidden') && detailsVisibility;
}

function isElementVisible(element, previousElement) {
  return isStyleVisible(element) && isAttributeVisible(element, previousElement) && (!element.parentElement || isElementVisible(element.parentElement, element));
}

function toBeVisible(element) {
  var _this = this;

  (0, _utils.checkHtmlElement)(element, toBeVisible, this);
  var isInDocument = element.ownerDocument === element.getRootNode({
    composed: true
  });
  var isVisible = isInDocument && isElementVisible(element);
  return {
    pass: isVisible,
    message: function message() {
      var is = isVisible ? 'is' : 'is not';
      return [_this.utils.matcherHint("".concat(_this.isNot ? '.not' : '', ".toBeVisible"), 'element', ''), '', "Received element ".concat(is, " visible").concat(isInDocument ? '' : ' (element is not in the document)', ":"), "  ".concat(_this.utils.printReceived(element.cloneNode(false)))].join('\n');
    }
  };
}